/* =========================================================
   KAYO – Panier tiroir : barre livraison + ligne livraison + upsell
   Ces éléments se recalculent tout seuls à chaque mise à
   jour du panier (ajout, quantité, suppression).
   (Timer de réservation retiré le 08/10/2026.)
   ========================================================= */
(function () {
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function rate() {
    var cur = (window.Shopify && Shopify.currency) || {};
    return parseFloat(cur.rate) || 1;
  }
  function currencyOf(el) {
    var cur = (window.Shopify && Shopify.currency) || {};
    return cur.active || el.dataset.currency;
  }
  function money(cents, currency, opts) {
    opts = opts || {};
    var value = cents / 100;
    var trim = opts.trim && value % 1 === 0;
    try {
      var out = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: trim ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
      return opts.code ? out + ' ' + currency : out;
    } catch (e) { return value.toFixed(2) + ' ' + currency; }
  }
  function withBold(template, token, value) {
    var parts = String(template).split(token);
    return parts.map(esc).join('<strong>' + esc(value) + '</strong>');
  }

  /* ---------- Livraison : MÊMES seuils et tarifs que Paramètres > Expédition ----------
     Seuil = l'équivalent de 100 $ dans chaque devise, arrondi à un chiffre rond.
     ⚠️ Ces montants doivent être IDENTIQUES à ceux de Paramètres > Expédition
     (tarif payant « jusqu'à X » et tarif gratuit « à partir de X » de chaque zone).
     Si tu changes un seuil ou un tarif dans Shopify, change-le aussi ici.

     Zones facturées en dollars mais affichées dans une autre devise (Reste du monde :
     Pologne, Hongrie, Suède...) : le seuil du checkout est 100 $ convertis au taux du jour.
     Le panier affiche ce montant arrondi au chiffre rond SUPÉRIEUR (ex : 391 zł -> 400 zł),
     pour ne jamais promettre la livraison offerte avant le checkout.
     Les valeurs écrites en haut de snippets/cart-drawer.liquid ne servent plus
     qu'au tout premier affichage : ce script les remplace. */
  var EURO = ['AD', 'AT', 'BE', 'BL', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GP', 'GR', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MC', 'MF', 'MQ', 'MT', 'NC', 'NL', 'PM', 'PT', 'RE', 'SI', 'SK', 'SM', 'VA', 'WF', 'YT'];
  var SHIP = {
    // Vérifié le 27/10/2026 contre Paramètres > Expédition (tarif payant sous le seuil / gratuit à partir du seuil)
    US: { cur: 'USD', goal: 100, fee: 3.95 },
    CA: { cur: 'CAD', goal: 140, fee: 4.95 },
    AU: { cur: 'AUD', goal: 140, fee: 4.95 },
    NZ: { cur: 'NZD', goal: 180, fee: 5.95 },
    CH: { cur: 'CHF', goal: 85, fee: 2.95 },
    GB: { cur: 'GBP', goal: 75, fee: 1.95 },
    PL: { cur: 'PLN', goal: 400, fee: 14.95 },
    EURO: { cur: 'EUR', goal: 90, fee: 2.95 },
    WORLD: { cur: 'USD', goal: 100, fee: 3.95 }
  };
  // Chiffre rond supérieur : par 5 sous 100, par 10 entre 100 et 999, par 100 entre 1 000 et 9 999...
  function roundUp(x) {
    var step = x < 100 ? 5 : Math.pow(10, Math.floor(Math.log10(x)) - 1);
    return Math.ceil(x / step - 1e-9) * step;
  }
  function shipCfg(el) {
    var country = String((window.Shopify && Shopify.country) || '').toUpperCase();
    var zone = SHIP[country] || (EURO.indexOf(country) > -1 ? SHIP.EURO : SHIP.WORLD);
    var active = currencyOf(el);
    // Zone affichée dans une autre devise que la sienne : on repasse sur la règle « 100 $ convertis »
    if (active !== zone.cur && zone.cur !== 'USD') zone = SHIP.WORLD;
    if (active !== zone.cur && zone.cur === 'USD') {
      var r = rate();
      return { goal: Math.round(roundUp(zone.goal * r) * 100), fee: Math.round(zone.fee * r * 100) };
    }
    return { goal: Math.round(zone.goal * 100), fee: Math.round(zone.fee * 100) };
  }

  /* ---------- Pastille de l'icône panier ----------
     Affiche le nombre de vrais articles (sans le produit de protection Navidium).
     Le nombre est lu dans le panier (kayo-ship[data-count]) et réappliqué
     chaque fois que le thème ou une app réécrit la pastille. */
  function realCount() {
    var s = document.querySelector('cart-drawer kayo-ship');
    return s ? parseInt(s.dataset.count, 10) || 0 : null;
  }
  function syncBubble() {
    var n = realCount();
    if (n === null) return;
    document.querySelectorAll('#cart-icon-bubble').forEach(function (link) {
      var b = link.querySelector('.cart-count-bubble');
      if (n === 0) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true"></span>';
        link.appendChild(b);
      }
      var num = b.querySelector('span[aria-hidden]');
      if (num && num.textContent.trim() !== String(n)) num.textContent = n;
    });
  }
  function watchBubble() {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (link) {
      if (link.dataset.kayoWatched) return;
      link.dataset.kayoWatched = '1';
      new MutationObserver(syncBubble).observe(link, { childList: true, subtree: true, characterData: true });
    });
    syncBubble();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBubble);
  else watchBubble();

  /* ---------- Barre livraison gratuite (multi-devises) ---------- */
  if (!customElements.get('kayo-fsb')) {
    customElements.define('kayo-fsb', class extends HTMLElement {
      connectedCallback() {
        var currency = currencyOf(this);
        var goal = shipCfg(this).goal; // seuil du checkout, dans la devise de la cliente
        var gross = parseInt(this.dataset.gross, 10) || 0;
        var left = Math.max(goal - gross, 0);
        var pct = goal > 0 ? Math.min((gross / goal) * 100, 100) : 100;

        var msg = this.querySelector('.kayo-fsb__msg');
        var fill = this.querySelector('.kayo-fsb__fill');
        if (fill) {
          // Animation : la barre part de son niveau précédent et se remplit jusqu'au nouveau montant
          var prev = typeof window.kayoFsbPct === 'number' ? window.kayoFsbPct : 0;
          fill.style.width = prev + '%';
          void fill.offsetWidth;
          requestAnimationFrame(function () { fill.style.width = pct + '%'; });
          window.kayoFsbPct = pct;
        }
        var track = this.querySelector('.kayo-fsb__track');
        if (track) track.setAttribute('aria-valuenow', Math.round(pct));
        this.classList.toggle('is-done', gross > 0 && left === 0);
        if (!msg) return;

        if (gross === 0) { msg.innerHTML = withBold(this.dataset.start, '[amount]', money(goal, currency, { trim: true })); return; }
        if (left === 0) { msg.innerHTML = '<strong>' + esc(this.dataset.done) + '</strong>'; return; }

        var amount = money(left, currency, { trim: true });
        msg.innerHTML = withBold(this.dataset.left, '[amount]', amount);
      }
    });
  }

  /* ---------- Ligne livraison + total (livraison incluse) ---------- */
  if (!customElements.get('kayo-ship')) {
    customElements.define('kayo-ship', class extends HTMLElement {
      connectedCallback() {
        var currency = currencyOf(this);
        var cfg = shipCfg(this); // mêmes seuil et tarif que le checkout
        var count = parseInt(this.dataset.count, 10) || 0;
        var goal = cfg.goal;
        var fee = cfg.fee;
        var gross = parseInt(this.dataset.gross, 10) || 0;
        var base = count > 0 ? parseInt(this.dataset.base, 10) || 0 : 0;
        var free = count > 0 && gross >= goal;
        var feeNow = count > 0 && !free ? fee : 0;

        this.classList.toggle('is-free', free);
        syncBubble();

        // Toujours réécrit (même en dollars) : le calcul Liquid du fichier cart-drawer n'est qu'une valeur de départ
        var value = this.querySelector('[data-kayo-ship-value]');
        if (value) value.textContent = free ? this.dataset.free : money(feeNow, currency);

        var footer = this.closest('.cart-drawer__footer');
        var total = footer && footer.querySelector('.kayo-total-value');
        if (total) total.textContent = money(base + feeNow, currency, { code: true });
      }
    });
  }

  /* ---------- Upsell : ajout au panier sans quitter le tiroir ---------- */
  if (!customElements.get('kayo-upsell')) {
    customElements.define('kayo-upsell', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('submit', this.onSubmit.bind(this));
        // Couleur : clic sur une vignette
        this.addEventListener('click', function (e) {
          var sw = e.target.closest('.kayo-upsell__swatch');
          if (!sw) return;
          sw.parentElement.querySelectorAll('.kayo-upsell__swatch').forEach(function (b) {
            b.classList.toggle('is-active', b === sw);
            b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
          });
          self.updateCard(sw.closest('[data-kayo-upsell-card]'));
        });
        // Taille (et autres options) : liste déroulante
        this.addEventListener('change', function (e) {
          if (e.target.matches('.kayo-upsell__select')) self.updateCard(e.target.closest('[data-kayo-upsell-card]'));
        });
        this.querySelectorAll('[data-kayo-upsell-card]').forEach(function (c) { self.updateCard(c); });
      }
      selection(card) {
        var sel = [];
        card.querySelectorAll('[data-option-index]').forEach(function (el) {
          var i = parseInt(el.dataset.optionIndex, 10);
          if (el.tagName === 'SELECT') sel[i] = el.value;
          else { var a = el.querySelector('.is-active'); sel[i] = a ? a.dataset.value : null; }
        });
        return sel;
      }
      updateCard(card) {
        if (!card) return;
        var json = card.querySelector('[data-kayo-variants]');
        if (!json) return;
        var variants;
        try { variants = JSON.parse(json.textContent); } catch (e) { return; }
        var sel = this.selection(card);
        var matches = function (v, skip) {
          return v.options.every(function (o, j) { return j === skip || sel[j] == null || o === sel[j]; });
        };

        // Grise les tailles indisponibles pour la couleur choisie, et bascule sur une taille dispo si besoin
        card.querySelectorAll('select[data-option-index]').forEach(function (s) {
          var i = parseInt(s.dataset.optionIndex, 10);
          Array.prototype.forEach.call(s.options, function (op) {
            op.disabled = !variants.some(function (v) { return v.available && v.options[i] === op.value && matches(v, i); });
          });
          if (s.selectedOptions[0] && s.selectedOptions[0].disabled) {
            var first = Array.prototype.find.call(s.options, function (op) { return !op.disabled; });
            if (first) { s.value = first.value; sel[i] = first.value; }
          }
        });

        var variant = variants.find(function (v) { return matches(v, -1); });
        var form = card.querySelector('form[data-kayo-upsell-form]');
        var btn = form && form.querySelector('.kayo-upsell__add');
        if (!variant || !form) return;

        form.querySelector('input[name="id"]').value = variant.id;
        var price = card.querySelector('.kayo-upsell__price');
        if (price) price.innerHTML = (variant.compare ? '<s>' + variant.compare + '</s>' : '') + variant.price;
        var img = card.querySelector('.kayo-upsell__media img');
        if (img && variant.image) img.src = variant.image;
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? form.dataset.add : form.dataset.sold;
        }
      }
      onSubmit(e) {
        var form = e.target.closest('form[data-kayo-upsell-form]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var err = form.querySelector('.kayo-upsell__error');
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        if (err) err.textContent = '';

        // FormData envoie aussi properties[_source] = cart-upsell (suivi de l'upsell dans les commandes)
        var body = new FormData(form);
        body.append('sections', 'cart-drawer,cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        fetch((window.routes && routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status) { // erreur Shopify (ex : stock insuffisant)
              if (err) err.textContent = state.description || state.message || '';
              return;
            }
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(state);
            } else {
              window.location.reload();
            }
          })
          .catch(function () { if (err) err.textContent = (window.cartStrings && cartStrings.error) || 'Error'; })
          .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
      }
    });
  }
})();

/* =========================================================
   KAYO – Paiement express : UN seul bouton, adapté à l'appareil
   Shopify reçoit uniquement le portefeuille choisi (une seule ligne, pas d'espace vide) :
   iPhone / Mac avec Apple Pay : Apple Pay  (sinon Shop Pay, puis PayPal)
   Android                     : Google Pay (sinon Shop Pay, puis PayPal)
   Autres                      : PayPal     (sinon Google Pay, puis Shop Pay)
   Si le portefeuille choisi ne s'affiche pas en 3 s, on passe au suivant.
   Pour changer l'ordre : modifier chain().
   ========================================================= */
(function () {
  function hasApplePay() {
    try { return !!(window.ApplePaySession && ApplePaySession.canMakePayments()); } catch (e) { return false; }
  }
  function chain() {
    var ua = navigator.userAgent || '';
    if (hasApplePay()) return ['apple', 'shop', 'paypal'];
    if (/Android/.test(ua)) return ['google', 'shop', 'paypal'];
    return ['paypal', 'google', 'shop'];
  }
  var CHAIN = chain();

  function drawnButton(out) {
    var host = out.querySelector('shopify-accelerated-checkout-cart');
    if (!host) return false;
    return Array.prototype.some.call(host.children, function (c) {
      return c.getBoundingClientRect().height > 10;
    });
  }

  function build(zone, step) {
    var tpl = zone.querySelector('template.kayo-express-tpl');
    if (!tpl || !zone.isConnected) return;
    var key = CHAIN[step];
    if (!key) { zone.classList.add('kayo-express--none'); return; }

    var frag = tpl.content.cloneNode(true);
    var host = frag.querySelector('shopify-accelerated-checkout-cart');
    if (host) {
      try {
        var list = JSON.parse(host.getAttribute('wallet-configs') || '[]');
        var keep = list.filter(function (w) { return String(w.name || '').toLowerCase().indexOf(key) > -1; });
        if (!keep.length) return build(zone, step + 1); // portefeuille non activé sur la boutique
        host.setAttribute('wallet-configs', JSON.stringify(keep));
      } catch (e) {}
    }
    var old = zone.querySelector('.kayo-express__out');
    if (old) old.remove();
    var out = document.createElement('div');
    out.className = 'kayo-express__out';
    out.appendChild(frag);
    zone.appendChild(out);
    zone.dataset.kayoWallet = key;

    // Panier vide : rien à vérifier (la zone est cachée)
    if (zone.dataset.count === '0') return;
    setTimeout(function () {
      if (!zone.isConnected || zone.dataset.kayoWallet !== key) return;
      if (!drawnButton(out)) build(zone, step + 1);
    }, 3000);
  }

  function scan() {
    document.querySelectorAll('.kayo-express').forEach(function (zone) {
      if (zone.dataset.kayoBuilt) return;
      zone.dataset.kayoBuilt = '1';
      build(zone, 0);
    });
  }
  function start() {
    scan();
    // Le panier est redessiné à chaque ajout / changement de quantité : on reconstruit la nouvelle zone
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
